import { render } from "./DeleteRelationModal.vue?vue&type=template&id=e75d85f4&ts=true"
import script from "./DeleteRelationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteRelationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__